import { useLocation, useNavigate } from 'react-router-dom';
import Button from '../../reusable/Button/Button';
import { t } from '../../i18n/i18n';
import './NotFound.scss';

/**
 * Any address that isn't a route — N70. It used to redirect to the dashboard
 * without a word, which hid a mistyped or outdated link instead of saying so.
 * Drawn inside the shell, so the sidebar is still there to go anywhere else.
 */
export default function NotFound() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (
    <section className="not-found" aria-labelledby="not-found-title">
      <span className="not-found__code" aria-hidden="true">
        404
      </span>
      <h1 id="not-found-title" className="not-found__title">
        {t('Page not found')}
      </h1>
      <p className="not-found__text">
        {t('Nothing lives at')} <code className="not-found__path">{pathname}</code>.{' '}
        {t('The link may be mistyped, or the page may have moved.')}
      </p>
      <div className="not-found__actions">
        <Button variant="pill" height={36} paddingInline={18} onClick={() => navigate('/dashboard')}>
          {t('Go to dashboard')}
        </Button>
        <Button variant="toolbar" height={36} onClick={() => navigate('/help-centre')}>
          {t('Help centre')}
        </Button>
      </div>
    </section>
  );
}
